import DateFilter from './Date/DateFilter';
import LocationsFilter from './LocationsFilter';
import HolidaysFilter from './HolidaysFilter';
import SectionsFilter from './SectionsFilter';
import SourcesFilter from './SourcesFilter';
import MediaTypeFilter from './MediaTypeFilter';
import TopicsFilter from './TopicsFilter';
import PublishersFilter from './PublishersFilter';
import YearsFilter from './YearsFilter';
import CollectionsFilter from './CollectionsFilter';
import LanguageFilter from './LanguageFilter';

const Filters = {
  DateFilter,
  LocationsFilter,
  HolidaysFilter,
  SectionsFilter,
  SourcesFilter,
  MediaTypeFilter,
  TopicsFilter,
  PublishersFilter,
  YearsFilter,
  CollectionsFilter,
  LanguageFilter,
};

export default Filters;
